import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncSynodDashboard({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/SynodDashboard"));
  console.log("Loading", AsyncSynodDashboard.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncSynodDashboard;
